import { LawsuitStatus } from '@declarations/common/enums/LawsuitStatus';
import { Option } from '@declarations/common/option';

export const LawsuitStatusOptions: Option<LawsuitStatus>[] = [
  { label: 'Open', value: LawsuitStatus.Open },
  { label: 'Re-opened', value: LawsuitStatus.ReOpened },
  { label: 'Closed', value: LawsuitStatus.Closed },
];
